import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { AFFILIATION_QUERY_PARAM, setCurrentAffiliation } from '../../AffiliationActions';

import withRouter from '../../../../components/Router/WithRouter';

function AffiliationInit({ dispatch, search }) {
	console.log('Affiliation', search, search[AFFILIATION_QUERY_PARAM]);
	useEffect(() => {
        if(search[AFFILIATION_QUERY_PARAM]) {
            dispatch(setCurrentAffiliation(search[AFFILIATION_QUERY_PARAM]));
        }
	}, []);

	return null;
}

AffiliationInit.propTypes = {
	dispatch: PropTypes.func.isRequired,
	search: PropTypes.object.isRequired,
};

export default connect()(withRouter(AffiliationInit, ['search']));
